import { ActivatedRouteSnapshot, RouteReuseStrategy, DetachedRouteHandle } from '@angular/router';

export class CustomRouteReuseStrategy implements RouteReuseStrategy {
  private readonly storedHandles = new Map<string, DetachedRouteHandle>();
  private readonly detachableRoutes = new Set(['library']);

  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    return this.detachableRoutes.has(route.routeConfig?.path ?? '');
  }

  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle | null): void {
    const path = route.routeConfig?.path ?? '';
    if (handle) {
      this.storedHandles.set(path, handle);
    } else {
      this.storedHandles.delete(path);
    }
  }

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    return this.storedHandles.has(route.routeConfig?.path ?? '');
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    return this.storedHandles.get(route.routeConfig?.path ?? '') ?? null;
  }

  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    // Force a reload if navigating between different model or collection IDs
    if (future.routeConfig?.path === 'model/:modelId' || future.routeConfig?.path === 'collection/:collectionId') {
      return false;
    }
    // Otherwise use default behavior
    return future.routeConfig === curr.routeConfig;
  }
}
